export default __webpack_public_path__ + "static/media/1327.8b914dda.png";